/** Which of the two lists a row came out of. */
export type ScopeFilter = 'any' | 'mine' | 'brokerage';

/**
 * The category filter, as a `<select>` value.
 *
 * Prefixed rather than sentinel strings, because there is no string that is
 * not also a category Keystone will hold: `category` is free text, the empty
 * string included, and a template filed nowhere has a null one. `named:` makes
 * every real category unambiguous whatever it is called, and `ungrouped`
 * selects the ones with no name to select them by — the same reading
 * `messageTemplates(categories: [null])` gives.
 */
export type CategoryFilter = 'any' | 'ungrouped' | `named:${string}`;

export function categoryOption(category: string): CategoryFilter {
  return `named:${category}`;
}

/** The category a `named:` filter selects, or null for the other two. */
export function selectedCategory(filter: CategoryFilter): string | null {
  return filter.startsWith('named:') ? filter.slice('named:'.length) : null;
}

/**
 * The status filter, and `any` is what the page opens on.
 *
 * Deliberately not Keystone's own default. An omitted `statuses` argument
 * means `ACTIVE` there, because the caller it was designed for is the composer
 * and a draft offered to an adviser is a half-written message sent to an
 * applicant. This is the other caller — a management screen, which is exactly
 * the one Keystone's docstring says names both — so the harness reads both and
 * narrows here.
 */
export type StatusFilter = 'any' | 'ACTIVE' | 'DRAFT';

export interface TemplateFilters {
  scope: ScopeFilter;
  category: CategoryFilter;
  status: StatusFilter;
  /** Matched against the current version's title, here rather than at
   *  Keystone: neither list field takes a title. */
  search: string;
}

export const EMPTY_FILTERS: TemplateFilters = {
  scope: 'any',
  category: 'any',
  status: 'any',
  search: '',
};
